import React from "react";

const ShowSuggestions = (props) => {
  return props.isQuickReplies ? (
    <>
      <div className="chatbot-suggestion-quick_reply mt-2">
        <div className="quick_reply-box" onClick={props.onAddAnother}>
          Add another {props.name}
        </div>
        <div className="quick_reply-box" onClick={props.onDone}>
          Done
        </div>
      </div>
    </>
  ) : (
    <>
      <div className="chatbot-suggestion-quick_reply mt-2">
        <div className="quick_reply-box" onClick={props.onShowMore}>
          Show 6 more candidates
        </div>
      </div>
    </>
  );
};

export default ShowSuggestions;
